<template>
  <span
    v-if="id"
    :class="className"
  >
    {{ $modeoL10n[id] }}
  </span>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    className: {
      type: Array,
      default: function() {
          return ['product-sticker'];
      },
    },
  },
};
</script>